export default "__VITE_PUBLIC_ASSET__9f56f5ce__"